export default {
  computed: {
    countries() {
      return this.$store.getters['Global/getAllCountries'];
    },

    states() {
      return this.$store.getters['Global/getAllStates'];
    },
  },
  methods: {
    async getStates(countryId) {
      this.state = null;
      await this.$store.dispatch('Global/fetchCountryStates', { countryId });
    },
    validation() {
      if (this.shipper.name === '') {
        this.errors.push('name');
      }

      if (this.shipper.phone === '') {
        this.errors.push('phone');
      }

      if (this.shipper.address === '') {
        this.errors.push('address');
      }

      if (!this.shipper.country) {
        this.errors.push('country');
      }

      if (!this.shipper.state) {
        this.errors.push('state');
      }
    },
  },
};
